import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Resources } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class MerchantNameVisibilityService {
  private readonly visibleSubject = new BehaviorSubject<boolean>(this.readStoredVisibility());

  readonly isVisible$: Observable<boolean> = this.visibleSubject.asObservable().pipe(distinctUntilChanged());

  get isVisible(): boolean {
    return this.visibleSubject.value;
  }

  show(): void {
    this.setVisibility(true);
  }

  hide(): void {
    this.setVisibility(false);
  }

  private setVisibility(isVisible: boolean): void {
    if (this.visibleSubject.value === isVisible) {
      return;
    }

    sessionStorage.setItem(Resources.MerchantNameHiddenKey, String(!isVisible));
    this.visibleSubject.next(isVisible);
  }

  private readStoredVisibility(): boolean {
    return sessionStorage.getItem(Resources.MerchantNameHiddenKey) !== 'true';
  }
}
